module.exports = __webpack_public_path__ + "img/botan_eat.40cb831d.gif";